/**
 * @generated SignedSource<<46add48a9ba298d2ba2d619ae0e425e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetKPIInput = {
  dataSource: string;
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAIntegrationKPIMutation$variables = {
  input: CreateWidgetKPIInput;
  storecastId: string;
};
export type WAIntegrationKPIMutation$data = {
  readonly dashboard: {
    readonly createWidgetKPI: {
      readonly id: string;
    };
  };
};
export type WAIntegrationKPIMutation = {
  response: WAIntegrationKPIMutation$data;
  variables: WAIntegrationKPIMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetKPI",
        "kind": "LinkedField",
        "name": "createWidgetKPI",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationKPIMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationKPIMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "80344ca8a22effa12d2f3764ce0d3e0c",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationKPIMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationKPIMutation(\n  $storecastId: ID!\n  $input: CreateWidgetKPIInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetKPI(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d07e8dbf6b2a22b5a96e5a2d52a14806";

export default node;
